import styled from 'styled-components';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';
import { Modal } from 'shared/components/modal/Modals';

export const ClientAccessManagerWrapper = styled.div`
  display: flex;
  .text-limit {
    max-width: 300px;
  }
  .backgroundbox-wrapper {
    @media ${device.sm} {
      flex: 0 0 94%;
      width: 97%;
      margin-left: 5px;
      .table {
        overflow-x: auto;
        display: block;
        max-width: fit-content;
        white-space: nowrap;
        table-layout: fixed;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }

      .action-header-mobile {
        flex-direction: column-reverse;
        .w-container-search-mobile {
          width: 100% !important;
          margin-top: 10px;
        }
      }
    }
    @media ${device.md} {
      flex: 0 0 94%;
      width: 97%;
      margin-left: 15px;
      .table {
        overflow-x: auto;
        display: block;
        max-width: fit-content;
        white-space: nowrap;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }
    }
    @media ${device.lg} {
      flex: 0 0 94%;
      width: 97%;
      margin-left: 15px;
      .table {
        overflow-x: auto;
        display: block;
        max-width: fit-content;
        white-space: nowrap;
        table-layout: fixed;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }
    }
    @media ${device.xl} {
      flex: 0 0 94%;
      width: 100%;
      margin-left: 0;
      .table {
        overflow-x: auto;
        display: inline-table;
        max-width: initial;
        white-space: nowrap;
        table-layout: fixed;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }
    }
  }
  .table-clients {
    height: 660px;
  }
  .action-row-client {
    cursor: pointer;
    &:hover {
      background-color: ${colors.lightGray};
    }
  }
`;

export const OptionMenu = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  height: 40px;
  padding-left: 1rem;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

export const FormWrapper = styled.form`
  display: block;
  margin-bottom: 30px;
  .form-container {
    height: auto;
  }
  .group-input-container {
    padding-top: 19px;
  }
  .e-multiselect.e-checkbox .e-multi-select-wrapper .e-searcher {
    display: none;
  }
  @media ${device.sm} {
    .mobile-input-container {
      margin-bottom: 19px;
    }
    .form-container {
      height: auto;
    }
  }
  .home__btn {
    height: 40px;
    width: 110px;
  }
  .required-mark {
    color: ${colors.error};
  }
`;

export const AccessManagerSelectorModal = styled(Modal)`
  height: auto;
  .modal-content {
    border-radius: 4px;
    padding: 30px 22.5px 30px 22.5px;
    height: auto;
  }
  .title-wrapper {
    border-bottom: 1px solid ${colors.black};
    padding-bottom: 15px;
    margin-bottom: 23.5px;
    width: 100%;
  }
  .title {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.xlg}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }
  .modal-header {
    border: 0;
    height: 11px;
    padding-top: 0px;
    padding-bottom: 0;
    padding-right: 0px;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .modal-body {
    padding: 0;
  }
`;
